import { useEffect } from 'react';
import { Beneficiario } from '../../interfaces/entities/Beneficiario';

const Chatbot = ({ benef }: { benef: Beneficiario }) => {
  useEffect(() => {
    if (!window.VI_API) {
      window.VI_API = {
        license: 'VI-88888867-1',
        source: 2,
        target: 2,
        customVars: [
          { 'name': 'nome', 'value': benef.nome },
          { 'name': 'cartao', 'value': benef.login },
          { 'name': 'email', 'value': benef.email },
          { 'name': 'cpf', 'value': benef.cpf }
        ]
      };

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'vi-camila-script';
      script.async = true;
      script.src = 'https://unimedcampinas.virtualinteractions.com.br/script/tracking.js?ms=' + new Date().getTime();
      document.body.appendChild(script);
    }
    // Ajuste para links do chatbot em dispositivos móveis
    const adjustChatbotLinks = () => {
      if (isMobileDevice()) {
        document.querySelector('#vi-camila-script')?.querySelectorAll('a[href]').forEach(link => {
          link.setAttribute('target', '_blank'); // Força a abrir em nova aba no mobile
        });
      }
    };

    const isMobileDevice = () => {
      return /Mobi|Android/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches;
    };

    // Timeout para aguardar o script carregar e links serem adicionados
    const timeoutId = setTimeout(adjustChatbotLinks, 2000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [benef]);

  return null;
};

export default Chatbot;